var isScriptLoaded = false;

function loadJSscripts() {
  if (!isScriptLoaded) {
    // Disconnect observer if it exists
    if (typeof observer !== "undefined") {
      observer.disconnect();
    }

    // Unblock yett if it exists
    if (typeof window.yett !== "undefined") {
      window.yett.unblock();
    }

    isScriptLoaded = true;

    // Load data-src for iframes, scripts, and images
    const elements = document.querySelectorAll("iframe[data-src], script[data-src], img[data-src]");
    elements.forEach(element => {
      const src = element.dataset.src;
      if (src !== null) {
        element.src = src;
      }
    });

    // Load data-href for links
    const links = document.querySelectorAll("link[data-href]");
    links.forEach(link => {
      const href = link.dataset.href;
      if (href !== null) {
        link.href = href;
      }
    });

    // Load lazy-load scripts
    const lazyScripts = document.querySelectorAll("script[type='text/lazyload']");
    lazyScripts.forEach(lazyScript => {
      const newScript = document.createElement("script");

      // Copy attributes from lazy-load script
      for (let i = 0; i < lazyScript.attributes.length; i++) {
        const attr = lazyScript.attributes[i];
        newScript.setAttribute(attr.name, attr.value);
      }

      newScript.type = "text/javascript";
      newScript.innerHTML = lazyScript.innerHTML;
      lazyScript.parentNode.insertBefore(newScript, lazyScript);
      lazyScript.parentNode.removeChild(lazyScript);
    });

    // Dispatch asyncLazyLoad event
    document.dispatchEvent(new CustomEvent("asyncLazyLoad"));
  }
}

// Listen for user activity events to trigger script loading
const userActivityEvents = [
  "mousedown",
  "mousemove",
  "keydown",
  "scroll",
  "touchstart",
  "click",
  "keypress",
  "touchmove"
];
userActivityEvents.forEach(event => {
  window.addEventListener(event, loadJSscripts, false);
});
